import { useState } from "react";
import useValoresNormales from "../../../../hooks/masters/useValoresNormales";
import {
  Page,
  Left,
  Right,
  HeaderRow,
  RoleListContainer,
  RoleItem,
  SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

/* ─── Acordeón (estilo idéntico a Users.js) ─── */
function Accordion({ title, count, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginBottom: "6px", border: "1px solid #e2e8f0", borderRadius: "6px" }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px 10px",
          background: open ? "#f1f5f9" : "#f8fafc",
          border: "none",
          borderRadius: open ? "6px 6px 0 0" : "6px",
          cursor: "pointer",
          fontSize: "11px",
          fontWeight: "600",
          color: "#1e40af",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {title}
          {count != null && (
            <span
              style={{
                background: "#dbeafe",
                color: "#2563eb",
                borderRadius: "10px",
                padding: "0 6px",
                fontSize: "10px",
                fontWeight: "700",
              }}
            >
              {count}
            </span>
          )}
        </span>
        <span style={{ fontSize: "10px", color: "#94a3b8" }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && <div style={{ padding: "6px 8px", borderTop: "1px solid #e2e8f0" }}>{children}</div>}
    </div>
  );
}

/* ─── Field: label arriba + input abajo (para grid 2 columnas) ─── */
function Field({ lbl, required, children, fullWidth = false }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "3px",
        gridColumn: fullWidth ? "1 / -1" : "auto",
      }}
    >
      <label style={{ fontSize: "11px", color: "#64748b", fontWeight: "500" }}>
        {lbl}
        {required && <span style={{ color: "#ef4444", marginLeft: "2px" }}>*</span>}
      </label>
      {children}
    </div>
  );
}

export default function ValoresNormales() {
  const {
    valores,
    consecutivos,
    subgrupos,
    selectedId,
    form,
    setForm,
    search,
    setSearch,
    loading,
    saving,
    handleSelect,
    handleNew,
    handleSave,
    handleDelete,
  } = useValoresNormales();

  return (
    <Page>
      {/* ══ PANEL IZQUIERDO ══ */}
      <Left>
        <HeaderRow>
          <h3 style={{ margin: 0, fontSize: "13px" }}>Valores Normales</h3>
          <BtnGeneral
            bg="cyan"
            padding="4px 8px"
            radius="5px"
            fw="600"
            fs="11px"
            onClick={handleNew}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        <SearchInput
          placeholder="Buscar x consecutivo, prueba..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <RoleListContainer>
          {loading ? (
            <div style={{ padding: "12px", color: "#94a3b8", textAlign: "center", fontSize: "11px" }}>
              Cargando registros...
            </div>
          ) : valores.length > 0 ? (
            valores.map((v) => (
              <RoleItem
                key={v.id}
                active={selectedId === v.id}
                onClick={() => handleSelect(v.id)}
              >
                <div>
                  <strong style={{ fontSize: "12px" }}>
                    {v.Consecutivo} {v.ConsecutivoNombre ? `- ${v.ConsecutivoNombre}` : ""}
                  </strong>
                  <div style={{ fontSize: "10px", color: "#64748b", marginTop: "2px" }}>
                    Tipo: <strong>{v.Tipo || "N"}</strong> | Rango:{" "}
                    <strong>
                      {v.Normal_min ?? "-"} a {v.Normal_max ?? "-"}
                    </strong>
                  </div>
                  <div style={{ fontSize: "10px", color: "#94a3b8" }}>
                    Edad: {v.edad_inicial ?? 0} a {v.edad_final ?? 120}a | Sexo: {v.sexo || "A"}
                  </div>
                </div>
              </RoleItem>
            ))
          ) : (
            <div style={{ padding: "12px", color: "#94a3b8", textAlign: "center", fontSize: "11px" }}>
              {search ? "No se encontraron valores normales" : "No hay registros configurados"}
            </div>
          )}
        </RoleListContainer>
      </Left>

      {/* ══ PANEL DERECHO ══ */}
      <Right style={{ overflowY: "auto", padding: "8px 10px" }}>
        <HeaderRow style={{ marginBottom: "6px" }}>
          <span style={{ fontSize: "11px", fontWeight: "600", color: "#334155" }}>
            {form.id
              ? `Editor: Valor Normal #${form.id} - Consecutivo ${form.Consecutivo}`
              : "Nuevo Valor Normal"}
          </span>
          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
            {form.id && (
              <BtnGeneral
                bg="red"
                padding="4px 12px"
                radius="5px"
                fw="600"
                fs="11px"
                onClick={() => handleDelete(form.id)}
              >
                Eliminar
              </BtnGeneral>
            )}
            <BtnGeneral
              bg="green"
              padding="4px 16px"
              radius="5px"
              fw="600"
              fs="11px"
              disabled={saving}
              onClick={handleSave}
            >
              {saving ? "Guardando..." : "Guardar"}
            </BtnGeneral>
          </div>
        </HeaderRow>

        {/* ── Sección: Datos Generales de la Prueba ── */}
        <Accordion title="Datos Generales de la Prueba" defaultOpen={true}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
            <Field lbl="ID:">
              <input
                style={{ ...inp, background: "#f8fafc", color: "#94a3b8" }}
                readOnly
                value={form.id || ""}
                placeholder="(Asignado automáticamente)"
              />
            </Field>

            <Field lbl="Consecutivo (Actividad / Prueba):" required>
              <SearchableSelect
                key={`select-cons-${form.id || "new"}`}
                value={form.Consecutivo ? String(form.Consecutivo) : ""}
                onValueChange={(val) => setForm({ ...form, Consecutivo: val })}
                options={consecutivos}
                getOptionValue={(c) => String(c.Consecutivo ?? c.id)}
                getOptionLabel={(c) => `${c.Consecutivo} - ${c.Api || "Sin descripción"}`}
                placeholder="Seleccione consecutivo..."
                multiple={false}
                searchable={true}
                sx={selectSx}
              />
            </Field>

            <Field lbl="Tipo de Dato:" required>
              <SearchableSelect
                key={`select-tipo-${form.id || "new"}`}
                value={form.Tipo || "N"}
                onValueChange={(val) => setForm({ ...form, Tipo: val })}
                options={[
                  { value: "N", label: "N - Numérico" },
                  { value: "A", label: "A - Alfanumérico" },
                  { value: "C", label: "C - Codificado" },
                ]}
                placeholder="Seleccione tipo..."
                multiple={false}
                searchable={false}
                sx={selectSx}
              />
            </Field>

            <Field lbl="Largo (Longitud máx):">
              <input
                type="number"
                style={inp}
                value={form.Largo}
                placeholder="Ej: 2"
                onChange={(e) => setForm({ ...form, Largo: e.target.value })}
              />
            </Field>

            <Field lbl="Orden de Presentación:">
              <input
                type="number"
                style={inp}
                value={form.Orden}
                placeholder="Ej: 1"
                onChange={(e) => setForm({ ...form, Orden: e.target.value })}
              />
            </Field>
          </div>
        </Accordion>

        {/* ── Sección: Rangos de Normalidad y Referencia ── */}
        <Accordion title="Rangos de Normalidad y Referencia" defaultOpen={true}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
            <Field lbl="Normal Mínimo:">
              <input
                type="number"
                step="any"
                style={inp}
                value={form.Normal_min}
                placeholder="Ej: 4.0"
                onChange={(e) => setForm({ ...form, Normal_min: e.target.value })}
              />
            </Field>

            <Field lbl="Normal Máximo:">
              <input
                type="number"
                step="any"
                style={inp}
                value={form.Normal_max}
                placeholder="Ej: 4.0"
                onChange={(e) => setForm({ ...form, Normal_max: e.target.value })}
              />
            </Field>

            <Field lbl="Valor Límite Mínimo:">
              <input
                type="number"
                step="any"
                style={inp}
                value={form.Valor_Minimo}
                placeholder="Límite mínimo permitido"
                onChange={(e) => setForm({ ...form, Valor_Minimo: e.target.value })}
              />
            </Field>

            <Field lbl="Valor Límite Máximo:">
              <input
                type="number"
                step="any"
                style={inp}
                value={form.Valor_maximo}
                placeholder="Límite máximo permitido"
                onChange={(e) => setForm({ ...form, Valor_maximo: e.target.value })}
              />
            </Field>

            <Field lbl="Texto de Valor Referencia:" fullWidth>
              <input
                style={inp}
                value={form.ValorReferencia}
                placeholder="Ej: Normal entre 4.0 y 4.0 mg/dL"
                onChange={(e) => setForm({ ...form, ValorReferencia: e.target.value })}
              />
            </Field>
          </div>
        </Accordion>

        {/* ── Sección: Criterios de Población (Edad y Sexo) ── */}
        <Accordion title="Criterios de Población (Edad y Sexo)" defaultOpen={true}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
            <Field lbl="Edad Inicial (Años):">
              <input
                type="number"
                step="any"
                style={inp}
                value={form.edad_inicial}
                placeholder="0"
                onChange={(e) => setForm({ ...form, edad_inicial: e.target.value })}
              />
            </Field>

            <Field lbl="Edad Final (Años):">
              <input
                type="number"
                step="any"
                style={inp}
                value={form.edad_final}
                placeholder="120"
                onChange={(e) => setForm({ ...form, edad_final: e.target.value })}
              />
            </Field>

            <Field lbl="Sexo Aplicable:" fullWidth>
              <SearchableSelect
                key={`select-sexo-${form.id || "new"}`}
                value={form.sexo || "A"}
                onValueChange={(val) => setForm({ ...form, sexo: val })}
                options={[
                  { value: "A", label: "A - Ambos (Masculino y Femenino)" },
                  { value: "M", label: "M - Masculino" },
                  { value: "F", label: "F - Femenino" },
                ]}
                placeholder="Seleccione sexo..."
                multiple={false}
                searchable={false}
                sx={selectSx}
              />
            </Field>
          </div>
        </Accordion>

        {/* ── Sección: Clasificación y Subgrupos ── */}
        <Accordion title="Clasificación y Subgrupos" defaultOpen={true}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
            <Field lbl="Subgrupo:">
              <SearchableSelect
                key={`select-subgrupo-${form.id || "new"}`}
                value={form.Subgrupo ? String(form.Subgrupo) : ""}
                onValueChange={(val) => setForm({ ...form, Subgrupo: val })}
                options={subgrupos}
                getOptionValue={(s) => String(s.id)}
                getOptionLabel={(s) => `${s.codigo || s.id} - ${s.descripcion}`}
                placeholder="Seleccione subgrupo..."
                multiple={false}
                searchable={true}
                sx={selectSx}
              />
            </Field>

            <Field lbl="AutoSubgrupo:">
              <SearchableSelect
                key={`select-autosubgrupo-${form.id || "new"}`}
                value={form.AutoSubgrupo ? String(form.AutoSubgrupo) : ""}
                onValueChange={(val) => setForm({ ...form, AutoSubgrupo: val })}
                options={subgrupos}
                getOptionValue={(s) => String(s.id)}
                getOptionLabel={(s) => `${s.codigo || s.id} - ${s.descripcion}`}
                placeholder="Seleccione auto subgrupo..."
                multiple={false}
                searchable={true}
                sx={selectSx}
              />
            </Field>

            <Field lbl="Acción / Recomendación Clínica:" fullWidth>
              <input
                style={inp}
                value={form.Accion}
                placeholder="Ej: Remitir a control médico si sale alterado"
                onChange={(e) => setForm({ ...form, Accion: e.target.value })}
              />
            </Field>
          </div>
        </Accordion>
      </Right>
    </Page>
  );
}

/* ─── Estilos idénticos a Users.js ─── */
const inp = {
  flex: 1,
  padding: "3px 7px",
  borderRadius: "4px",
  border: "1px solid #cbd5e1",
  fontSize: "11px",
  boxSizing: "border-box",
  outline: "none",
  marginBottom: 0,
};

const selectSx = {
  minWidth: 0,
  "& .MuiOutlinedInput-root": {
    height: "26px",
    minHeight: "26px",
    borderRadius: "4px",
    fontSize: "11px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": {
      borderColor: "#cbd5e1",
    },
    "&:hover fieldset": {
      borderColor: "#94a3b8",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#3b82f6",
    },
  },
  "& .MuiSelect-select": {
    padding: "2px 8px !important",
    display: "flex",
    alignItems: "center",
    fontSize: "11px",
    fontFamily: "var(--font-body)",
  },
};

